const {
  geoPoint
} = require('../serialize');

const dictionaryToGeoIds = (dictionary
/*: { [string]: Array<GeoPoint> }*/
) =>
/*: Array<GeoId>*/
Object.entries(dictionary).map(([id, centres]) => ({
  id,
  centres: ((centres
  /*: any*/
  )
  /*: Array<GeoPoint>*/
  ) // Flow is such crap

}));

const geoIdsToDictionary = (list
/*: Array<GeoId>*/
) =>
/*: { [string]: Array<GeoPoint> }*/
{
  if (!list) return undefined;
  return list.reduce((acc, {
    id,
    centres = []
  }) => {
    acc[id] = centres.map(geoPoint);
    return acc;
  }, {});
};

module.exports = {
  dictionaryToGeoIds,
  geoIdsToDictionary
};